export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0e6b63] py-10 text-center"
    >
      <p className="font-body text-sm tracking-wide text-white">
        © Azzaro Resorts &amp; Spa. All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
